import { useState } from "react";
import { useSelector } from "react-redux";
import BreadCrumbsContainer from "../../Common/Breadcrumbs";
import { Outlet } from "react-router-dom";

const ProductionScreen = () => {
  const sidebar = useSelector(state => state.sidebar);

  return (
    <div className="dashboardOuterContainer">
      <div
        className={`${
          sidebar.expand
            ? "dashboardInnerSidebarBig"
            : "dashboardInnerSidebarSmall"
        }`}>
        <BreadCrumbsContainer />
        <div className="dashboardDataCardContainer overflow-x-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ProductionScreen;
